<template>
  <div class="w-100 h-100 d-flex flex-column justify-space-between">
    <div class="mx-auto">Moinaaas</div>
    <twitch-player class="mx-auto"></twitch-player>
  </div>
</template>

<script lang="ts">
import TwitchPlayer from "@/components/TwitchPlayer.vue";
import Vue from "vue";

export default Vue.extend({
  components: { TwitchPlayer },
  name: "HomeView",
});
</script>
